import React from 'react'

import Text from 'components/_new/typography/Text/Text'
import Price from 'components/text/Price/Price'

import messages from './messages'

import s from './TotalPrice.scss'


const PaymentTotalPrice = ({ isFetching, total }) => (
  <div className={s.total} id="billSubscriptionTotalRow">
    <Text uppercase message={messages.total} />
    <Price value={total} loading={isFetching} isCents />
  </div>
)

export default React.memo(PaymentTotalPrice)
